import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, ListOrdered, PiggyBank, Wallet, Rocket } from 'lucide-react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const FooterNav = () => {
    const { token } = useAuth();
    const [recordsAlert, setRecordsAlert] = useState(false);

    useEffect(() => {
        const fetchRecords = async () => {
            if (!token) return;
            try {
                const res = await axios.get('/api/ratings/user', {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const pending = res.data.filter(r => r.status && r.status.toLowerCase() === 'pending').length;
                const inprogress = res.data.filter(r => r.status && r.status.toLowerCase() === 'in progress').length;
                setRecordsAlert((pending + inprogress) > 0);
            } catch (err) {
                setRecordsAlert(false);
            }
        };
        fetchRecords();
        const interval = setInterval(fetchRecords, 30000);
        return () => clearInterval(interval);
    }, [token]);

    const navItems = [
        { to: '/', icon: Home, label: 'Home' },
        { to: '/records', icon: ListOrdered, label: 'Records' },
        { to: '/start', icon: Rocket, label: 'Start', isCentral: true },
        { to: '/deposit', icon: PiggyBank, label: 'Deposit' },
        { to: '/withdraw', icon: Wallet, label: 'Withdraw' },
    ];

    const NavItem = ({ to, icon: Icon, label, isCentral }) => {
        const baseClasses = "flex flex-col items-center justify-center gap-1 transition-colors duration-300";
        const activeClasses = "text-cyan-400";
        const inactiveClasses = "text-slate-400 hover:text-white";

        if (isCentral) {
            return (
                <NavLink to={to}>
                    <div className="relative">
                        <motion.div 
                            className="absolute -top-12 left-1/2 -translate-x-1/2 w-20 h-20 bg-gradient-to-br from-cyan-400 to-blue-600 hover:scale-110 transition-all duration-300 rounded-full flex items-center justify-center shadow-lg shadow-cyan-500/30"
                        >
                             <div className="flex flex-col items-center text-white">
                                <Icon size={28} />
                                <span className="text-sm font-bold mt-1">{label}</span>
                            </div>
                        </motion.div>
                    </div>
                </NavLink>
            );
        }
        
        return (
            <NavLink to={to} className={({ isActive }) => `${baseClasses} ${isActive ? activeClasses : inactiveClasses} relative`}>
                <Icon size={24} />
                <span className="text-xs font-medium">{label}</span>
                {label === 'Records' && recordsAlert && (
                    <span className="absolute -top-1 -right-1 h-3 w-3 bg-red-500 rounded-full border-2 border-gray-900 animate-pulse"></span>
                )}
            </NavLink>
        );
    };

    return (
         <footer className="fixed bottom-0 left-0 right-0 z-40 p-4">
            <div
                className="w-full max-w-2xl mx-auto bg-gray-900/40 backdrop-blur-xl border border-white/10 shadow-lg rounded-2xl flex items-center justify-around p-3 relative"
            >
                {navItems.map(item => <NavItem key={item.label} {...item} />)}
            </div>
        </footer>
    );
};

export default FooterNav;
